import { HebDateUtil } from '../Util/HebDateUtil';
import { HDate } from '@hebcal/core';
import { DataBroker } from './DataBroker';

function GetShiurIndex(date) {
	const TodayDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	const FirstDate = new Date(1984, 4-1, 28);
	const DaysDiff = Math.round((TodayDate.getTime() - FirstDate.getTime()) / (1000 * 3600 * 24));

	let diff = (DaysDiff % 339);
	return (diff === 0) ? 339 : diff;
};

function RenderShiur(data, hDate) {
	return	<div className='SeferMitsvot'>
				<center className='shiur-title'><b>ספר מצוות ליום { HebDateUtil.GetHebrewDateShort(hDate) }</b></center>
				<div dangerouslySetInnerHTML={{ __html: data }} />
			</div>;

};

export async function GetSM(gregDate) {
	const hDate = new HDate(gregDate);
	const index = GetShiurIndex(gregDate);
	let data = await DataBroker.getDataText('sm/' + index);

	if (data !== null)
		data = data.replaceAll("(", "<small class=\"quote\">(").replaceAll(")", ")</small>");

	return new Promise((myResolve, myReject) => {
		if (data === null)
			myReject(DataBroker.getError());
		else
			myResolve(RenderShiur(data, hDate));
	});
};